import { styled } from "goober";

export const BadgeDot = styled("div")`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--orange-600);
`;
